module.exports = __webpack_public_path__ + "img/canceldownload.32bf6a33.png";